import type { Iteration } from '@rhythmic/db/types'
import type { UseLiveQueryReturn } from '@tanstack/vue-db'
import { useLiveQuery } from '@tanstack/vue-db'
import type { MaybeRefOrGetter } from 'vue'
import { computed, toValue } from 'vue'
import { useRhythmicLogger } from '#imports'
import { TEAM_ITERATION_TABLE } from '../collections'
import { useCollection } from '../composables/useCollection'

/**
 * Query teams by workspace - accepts a reactive workspace ref
 * This allows proper reactive chaining when workspace is already loaded
 */
export function useIterationsByTeam(
  teamId: MaybeRefOrGetter<string | null | undefined>,
): UseLiveQueryReturn<Iteration> | undefined {
  const logger = useRhythmicLogger('useIterationsByTeam')

  const teamIdValue = computed(() => toValue(teamId))

  if (!teamIdValue.value) {
    logger.debug('Skipping iterations query: missing team')
    return undefined
  }

  const { collection } = useCollection<Iteration>(TEAM_ITERATION_TABLE, {
    team_id: teamIdValue.value,
  })

  const query = useLiveQuery(
    (builder) => builder.from({ t: collection }).orderBy(({ t }) => t.start_date, 'asc'),
    [() => collection, () => teamIdValue.value],
  )

  return query
}
